// Static index of the canonical schema JSONs (mirrored from Pulse_Base
// backend/.../canonical/schema). Webpack bundles each at build time so the
// schema viewer runs without a backend round-trip.

import account from './account.json';
import campaign from './campaign.json';
import company from './company.json';
import contact from './contact.json';
import customer from './customer.json';
import deal from './deal.json';
import emailAggregate from './email_aggregate.json';
import employee from './employee.json';
import engagement from './engagement.json';
import expectedPayment from './expected_payment.json';
import lead from './lead.json';
import lifecycleEvent from './lifecycle_event.json';
import meeting from './meeting.json';
import plEntry from './pl_entry.json';
import product from './product.json';
import searchPerformance from './search_performance.json';
import seoMetric from './seo_metric.json';
import timeEntry from './time_entry.json';
import touchpoint from './touchpoint.json';
import transaction from './transaction.json';
import webSession from './web_session.json';
import relationshipMap from './relationship_map.json';

export const CANONICAL_SCHEMAS = [
  account, campaign, company, contact, customer, deal,
  emailAggregate, employee, engagement, expectedPayment,
  lead, lifecycleEvent, meeting, plEntry, product,
  searchPerformance, seoMetric, timeEntry, touchpoint,
  transaction, webSession,
];

export const CANONICAL_RELATIONSHIPS = relationshipMap.relationships || [];
